import { faFilePdf } from '@fortawesome/pro-regular-svg-icons'
import { DocumentItem, DocumentItemInput, ItListItem } from 'types/graphql'

import documentPlaceholder from 'src/assets/image/placeholder-pdf.jpg'

import { ItemDescription } from '..'

import Builder from './Builder'
import Header from './Header'

export const itemDescription: ItemDescription<DocumentItem, DocumentItemInput> =
  {
    hasCustomFields: true,
    type: 'document',
    icon: faFilePdf,
    label: 'PDF',
    thumbnail: (item: ItListItem) =>
      item.document.coverUrl || documentPlaceholder,
    generateEmptyItemDetails() {
      return {
        type: '',
        fileName: '',
        documentUrl: '',
        coverUrl: '',
        onlyAvailableOnItList: false,
      }
    },
    convertToGQLInput({
      documentUrl,
      coverUrl,
      fileName,
      type,
      id,
      onlyAvailableOnItList,
    }: DocumentItem): DocumentItemInput {
      return {
        hasDocument: !!documentUrl,
        hasCover: !!coverUrl,
        fileName,
        type,
        id,
        onlyAvailableOnItList,
      }
    },
    Header,
    Builder,
  }
